<template>
  <div class="inputgroup-append">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "InputgroupAppend",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.inputgroup-append {
  @include flex(flex, flex-start, center, row, nowrap);
}
</style>
